import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const serverUrl = "/api";

const PartnerLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch(serverUrl + '/partner/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            const data = await res.json();
            if (res.ok) {
                if (data.partner.must_change_password) {
                    localStorage.setItem('partner_temp_token', data.token);
                    navigate('/partner/change-password');
                } else {
                    localStorage.setItem('partner_token', data.token);
                    localStorage.setItem('partner_name', data.partner.name);
                    navigate('/partner/dashboard');
                }
            } else {
                setError(data.error || 'Login failed');
            }
        } catch (err) {
            setError('Server error');
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f4f4' }}>
            <form onSubmit={handleLogin} style={{ background: '#fff', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', width: '300px', display: 'flex', flexDirection: 'column' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#a239ca' }}>Partner Portal</h2>
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    style={{ padding: '10px', marginBottom: '15px', borderRadius: '5px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box' }}
                    required
                />
                <div style={{ position: 'relative', width: '100%', marginBottom: '15px' }}>
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        style={{ padding: '10px', paddingRight: '40px', borderRadius: '5px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box', margin: 0 }}
                        required
                    />
                    <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>
                <button type="submit" style={{ padding: '10px', backgroundColor: '#a239ca', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', width: '100%', boxSizing: 'border-box' }}>Login</button>
                {error && <p style={{ color: 'red', fontSize: '12px', marginTop: '15px', textAlign: 'center' }}>{error}</p>}
            </form>
        </div>
    );
};

export default PartnerLogin;
